import React from "react";

import { Arrow } from "@ui/Assets/MyIcons";
import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { Text } from "@ui/Atoms/Text";

import { useTranslate } from "@hooks/useTranslate";
import { useBreakpoint } from "@hooks/useBreakpoint";

import type { TBodyProps, RowProps } from "./Table.types";
import * as Styled from "./Table.styled";

export const TBody: React.FC<TBodyProps> = props => {
  const translate = useTranslate("batmaid_pwa_generic");
  const { mobile } = useBreakpoint("v1");

  const [isOpened, setIsOpened] = React.useState(false);

  const childrenAmount = React.Children.toArray(props.children).filter(child =>
    React.isValidElement<RowProps>(child),
  ).length;

  const toggleHandler = () => {
    setIsOpened(current => {
      const newState = !current;

      props.onToggle?.(newState);
      return newState;
    });
  };

  return (
    <TestWrapper testId={props.testId}>
      <Styled.TBody data-opened={isOpened}>
        <Styled.TransparentRow />
        <Styled.TBodyHeader>
          <Text as="td" $style="medium_16">
            <Styled.Counter>
              <div>{props.headerLabels[0]}</div>
            </Styled.Counter>
          </Text>
          <Text as="td" $style="regular_16">
            {props.headerLabels[1]}
          </Text>
          <Text as="td" $style="regular_16">
            {props.headerLabels[2]}
          </Text>

          <td>
            {!!childrenAmount && (
              <Styled.DetailsButton
                colorType="blue"
                variantStyle="text"
                size="small"
                icon={mobile ? "alone" : "right"}
                iconComponent={Arrow}
                onClick={toggleHandler}
              >
                {translate("details")}
              </Styled.DetailsButton>
            )}
          </td>
        </Styled.TBodyHeader>

        {props.children}
      </Styled.TBody>
    </TestWrapper>
  );
};
